module.exports = __webpack_public_path__ + "staticcomp/img/content_4.c833383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_4.jpg
// module id = BVqC
// module chunks = 39